<div class="tree-content">
  <!--  in caso la structure abbia un solo nodo-->
  <ng-container *ngIf="treeData.length===1">
    <div class="text-center">
      <ng-container *ngFor="let node of treeData">
        <div class="">
          <div class="col border-secondary border rounded rounded-900 p-3 node text-truncate d-block"
               title="{{node.description || node.code}}"
               [ngClass]="{'customer':node.customerCode,'account':node.accountCode, 'bg-white':!node.customerCode && !node.accountCode}">
            <div class="row justify-content-center text-truncate d-block">{{node.description || node.code}}</div>
            <ng-container *ngIf="node.customerCode">
              <div
                class="row justify-content-center font-weight-bold mt-2">{{"PAGE.CLIENT_ACCOUNT_CHOICE.FORMS.LABELS.CLIENT" | translate}}</div>
              <div class="row justify-content-center">
                <div class="badge badge-light">{{node.customerCode}}</div>
              </div>
            </ng-container>
            <ng-container *ngIf="node.accountCode">
              <div
                class="row justify-content-center font-weight-bold mt-2">{{"PAGE.CLIENT_ACCOUNT_CHOICE.FORMS.LABELS.ACCOUNT" | translate}}</div>
              <div class="row justify-content-center">
                <div class="badge badge-light">{{node.accountCode}}</div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="separator" *ngIf="!node.accountCode"></div>
        <app-tree *ngIf="node.structure" [treeData]="node.structure"></app-tree>
      </ng-container>
    </div>
  </ng-container>

  <!--  in caso la structure abbia più nodi-->
  <ng-container *ngIf="treeData.length>1">
    <div class="col">
      <div class="separator"></div>
    </div>
    <div class="row">
      <ng-container *ngFor="let node of treeData;let f = first; let l = last">
        <div class="col">
          <div class="row tree" [ngClass]="{'left':f,'right':l}">
          </div>
          <div *ngIf="!f && !l" class="separator" style="position: absolute;top:0"></div>
        </div>
      </ng-container>
    </div>

    <div class="row flex-nowrap m-0 p-0">
      <ng-container *ngFor="let node of treeData;let first = first; let last = last">
        <div class="col border-secondary border rounded rounded-900 p-3 node text-truncate d-block"
             title="{{node.description || node.code}}"
             [ngClass]="{'ml-2 mr-2':!first && !last,'customer':node.customerCode,'account':node.accountCode}">{{node.description || node.code}}</div>
        <app-tree *ngIf="node.structure" [treeData]="node.structure"></app-tree>
      </ng-container>
    </div>
  </ng-container>
</div>

